var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5857864,12.5857864 L16.5868299,12.5857864 C17.1385384,12.5857864 17.5857864,13.0236678 17.5857864,13.5887158 L17.5857864,18.5828571 C17.5857864,19.1367597 17.1431261,19.5857864 16.5868299,19.5857864 L15.584743,19.5857864 C15.0330345,19.5857864 14.5857864,19.1479051 14.5857864,18.5828571 L14.5857864,12.5857864 Z",
  transform: "translate(16.085786, 16.085786) rotate(-45.000000) translate(-16.085786, -16.085786) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5,16 C5.35786438,16 2,12.6421356 2,8.5 C2,4.35786438 5.35786438,1 9.5,1 C13.6421356,1 17,4.35786438 17,8.5 C17,12.6421356 13.6421356,16 9.5,16 Z M9.5,13 C11.9852814,13 14,10.9852814 14,8.5 C14,6.01471863 11.9852814,4 9.5,4 C7.01471863,4 5,6.01471863 5,8.5 C5,10.9852814 7.01471863,13 9.5,13 Z"
})))));
export default SvgSearch;